import { getPathname } from '@shared/selectors';
import { ROUTES } from '@services/routes.service';

function getFallbackUrl(state) {
  const pathname = getPathname(state);
  if (pathname) {
    const landingUrl = pathname.substring(0, pathname.lastIndexOf('/'));
    return landingUrl;
  }
  return ROUTES.HOME;
}

export default getFallbackUrl;
